import Cookies from "js-cookie";
import httpservice from "./httpservice";
import { EventSourcePolyfill } from "event-source-polyfill";

class NotificationService {
  get(query = {}) {
    const params = {};
    if (query?.page) params.page = query.page;
    if (query?.limit) params.limit = query.limit;
    return httpservice.get("/admin/cp/activities/admin", { params });
  }

  listen(onMessage, onError) {
    const token = Cookies.get("administrator_access_auth");
    const eventSource = new EventSourcePolyfill("/", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    eventSource.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data);
        onMessage(parsed);
      } catch {
        onMessage(event.data);
      }
    };

    eventSource.onerror = (error) => {
      console.error("SSE connection error:", error);
      onError?.(error);
    };

    return eventSource;
  }
}

export default new NotificationService();
